import React, { useEffect } from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Button, Form, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../../common/forms/FormItem';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';
import Select from '../../../../common/forms/select/Select';
import { getUniqueLocations } from '../../../cargo/unloading-cargo-from-itinerary/UnloadingCargoForm';
import { clearItinerary } from '../../../../../actions';

const ChangeLocationForm = ({
  handleSubmit,
  onCancel,
  itineraryCounter,
  dispatchClearItinerary,
}) => {
  useEffect(
    () => () => {
      dispatchClearItinerary();
    },
    [dispatchClearItinerary],
  );

  if (!itineraryCounter || itineraryCounter.isEmpty()) {
    return null;
  }

  const getOriginLocationsOptions = () =>
    getUniqueLocations(itineraryCounter, false, true).map((location) => ({
      value: location.id,
      label: location.name,
    }));

  const getDestinationLocationsOptions = () =>
    getUniqueLocations(itineraryCounter, true, false).map((location) => ({
      value: location.id,
      label: location.name,
    }));

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Ubicación Origen" required>
          <Field
            name="newSourceLocation"
            component={Select}
            options={getOriginLocationsOptions()}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Ubicación Destino" required>
          <Field
            name="newDestinationLocation"
            component={Select}
            options={getDestinationLocationsOptions()}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter>
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );
};

ChangeLocationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  itineraryCounter: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchClearItinerary: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  itineraryCounter:
    state.ItineraryUnit.Itinerary.getIn(['current', 'content']) || undefined,
});

const mapDispatchToProps = {
  dispatchClearItinerary: clearItinerary,
};

const formComponent = reduxForm({
  form: 'ChangeLocationForm',
  enableReinitialize: true,
})(ChangeLocationForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
